import { Popup } from '@paywithextend/components'
import React from 'react'
import ConfirmationPopupContent from 'src/components/ConfirmationPopupContent/ConfirmationPopupContent'
import { useFlyoutDispatch } from 'src/hooks'
import { closeModal } from 'src/navigation/Lnk'

interface CancelOrDeactivateVirtualCardsPopupProps {
  title: React.ReactNode
  subtitle: React.ReactNode
  actionButtonLabel: React.ReactNode
  actionButtonLoading?: boolean
  actionButtonOnClick: () => void
  cancelButtonLabel: React.ReactNode
  cancelButtonOnClick?: () => void
  topLevelError?: string
}

const CancelOrDeactivateVirtualCardsPopup: React.FC<
  CancelOrDeactivateVirtualCardsPopupProps
> = (props) => {
  const dispatch = useFlyoutDispatch()

  return (
    <Popup
      onClickClose={
        props.cancelButtonOnClick ||
        ((): void => {
          dispatch(closeModal())
        })
      }
      showCloseButton
    >
      <ConfirmationPopupContent
        title={props.title}
        subtitle={props.subtitle}
        actionButtonLabel={props.actionButtonLabel}
        actionButtonLoading={props.actionButtonLoading}
        actionButtonOnClick={props.actionButtonOnClick}
        cancelButtonLabel={props.cancelButtonLabel}
        cancelButtonOnClick={props.cancelButtonOnClick}
        topLevelError={props.topLevelError}
      />
    </Popup>
  )
}

export default CancelOrDeactivateVirtualCardsPopup
